import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Logo } from "../../components/Layouts";

export default function ResetPassword() {
  return (
    <div className="auth-page">
      <div className="auth-aside">
        <Logo />
        <div><div className="eyebrow">ACCOUNT RECOVERY</div><h1>Protect every<br /><em>sign-in.</em></h1><p>Email password reset links are disabled. Recovery is handled by an administrator.</p></div>
        <div className="auth-foot">© {new Date().getFullYear()} World Help Agency</div>
      </div>
      <div className="auth-form-wrap">
        <div className="auth-form">
          <ShieldCheck size={30} />
          <h2>Reset link unavailable</h2>
          <div className="note" data-testid="reset-link-disabled">Contact an administrator if you cannot access your account.</div>
          <div className="form-switch"><Link data-testid="reset-back-to-login" to="/login">Back to sign in</Link></div>
        </div>
      </div>
    </div>
  );
}